import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { SocialPostDetailsComponent } from '../social-post-details/social-post-details.component';

@Component({
  imports: [SocialPostDetailsComponent],
  selector: 'app-instagram-story-details',
  templateUrl: './instagram-story-details.component.html',
})
export class InstagramStoryDetailsComponent extends DeliverableAnalyticsContentDirective {}
